/** Settings › Voice › Vocabulary: the word list, one word, suggestions from Memory and Fix a word. */
export default {
  vocabulary: "Vocabulary",
  vocabularyEmpty: "Words Denker should always get right",
  vocabularyMore: "{names} and {count} more",
  heardAsSummary: "Heard as {words}",
  notMisheard: "Not misheard yet",
  addWordPlaceholder: "Add a word or name",
  add: "Add",
  addWordFailed: "Couldn’t add the word. Try again.",
  removeWordFailed: "Couldn’t remove the word. Try again.",
  listFootnote:
    "Denker listens for these words in all voice input and fixes them when they’re misheard.",
  fromMemory: "From Memory",
  kindPerson: "Person",
  kindProject: "Project",
  kindCompany: "Company",
  notNeeded: "Not needed",
  hideSuggestionFailed: "Couldn’t hide the suggestion. Try again.",
  word: "Word",
  heardAs: "Heard as",
  removeHeard: "Remove {text}",
  heardAsFootnote:
    "Denker learns these when you fix a word. Remove one if it was a mistake.",
  removeWord: "Remove word",
  renameConflict: "Another word in the list is spelled like that.",
  renameFailed: "Couldn’t rename the word. Try again.",
  heardAsInvalid: "Use up to four words that differ from the word itself.",
  addFailed: "Couldn’t add it. Try again.",
  removeFailed: "Couldn’t remove it. Try again.",
  rightWord: "Right word",
  remember: "Remember",
  rememberFailed: "Couldn’t remember the word. Try again.",
  fixHintMore: "Click a word next to it to include it too.",
  fixHint: "Click the word that was misheard.",
} as const;
